export default __webpack_public_path__ + "static/media/error404.9a7759ee.jpg";